﻿import {EpochsController} from "./EpochsController";
import {TapChallengeMode} from "./TapChallengeMode";
import {PlayerPrefs} from "../Utils/Unity/PlayerPrefs";
import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";
import {EpochsView} from "./Views/EpochsView";
import {MoneyType, UIState, UpgradeType} from "../enums";
import {Core} from "../Base/Core";
import {Random} from "../Utils/Unity/Random";
import {Time} from "../Utils/Unity/Time";

const UPDATE_PERIOD = 1;

export const TUTORIAL_STATE = {
    BUBBLE1: 1,
    WAIT_BUBBLE1: 2,
    BUBBLE2: 3,
    WAIT_BUBBLE2: 4,
    MERGE: 5,
    MERGED: 6,
    BUBBLE3: 7,
};

class GameManagerClass extends MonoBehaviour {

    get tutorialState() {
        return PlayerPrefs.GetInt("eruycberuwtfxb832tb46tr384", -1);
    }

    set tutorialState(value) {
        PlayerPrefs.SetInt("eruycberuwtfxb832tb46tr384", value);
    }

    get timeOfLastBubbleSpawn() {
        return ~~PlayerPrefs.GetInt(
            "timeOfLastBubbleSpawn" + this.currentPlanetId,
            Time.time - this.bubbleSpawnPeriod
        );
    }

    set timeOfLastBubbleSpawn(value) {
        PlayerPrefs.SetInt("timeOfLastBubbleSpawn" + this.currentPlanetId, value || 0);
    }

    get timeFromLastBubbleSpawn() {
        return Time.time - this.timeOfLastBubbleSpawn;
    }

    callOnEpochSelected(epochId) {
        this.emit("EpochSelected", epochId);
    }

    UpdateCurrentPlanet() {
        if (!Core.Player.PlanetsSave.CurrentPlanet) return;
        this.currentPlanetId = Core.Player.PlanetsSave.CurrentPlanet.planetId;
        this.initializePlanet(Core.Player.PlanetsSave.CurrentPlanet);
        this.gameView.SelectEpoch(Core.Player.PlanetsSave.CurrentPlanet.StartEpoch, false, 0);
        this.updateTimers();
        this.onPlayerChanged();
    }

    GetRandomPointInCameraView() {
        let {width, height} = Core.app.viewport;
        let sidePadding = 0.1;

        if (this.tutorialState === TUTORIAL_STATE.BUBBLE1) {
            return new PIXI.Point(width * 0.5, height * 0.6);
        }
        if (this.tutorialState === TUTORIAL_STATE.BUBBLE2) {
            return new PIXI.Point(width * 0.4, height * 0.4);
        }

        return new PIXI.Point(
            Random.Range(width * sidePadding, width * (1 - sidePadding * 2)),
            Random.Range(height * sidePadding, height * (1 - sidePadding * 2))
        );
    }

    Awake() {
        this.TapChallengeMode = null; // TapChallengeMode
        this.gameView = null; // EpochsView
        this.Prespawn = false;
        this.cam = null; // Camera
        this.bubbleSpawnPeriod = 0; // float
        this.currentPlanetId = 0;
        this.timeFromLastUpdate = 0; // float
        this.ticksInMillisecond = 10000;
        this.ticksInSecond = this.ticksInMillisecond * 1000;
        this.touchStartPosition = null; // Vector2
        this.touchId = 0; // int
        this.tutorialTimer = 0; // float

        this.HandleCreatureClick = this.HandleCreatureClick.bind(this);
        this.HandleTapChallengeActivated = this.HandleTapChallengeActivated.bind(this);
        this.HandleTapChallengeStarted = this.HandleTapChallengeStarted.bind(this);
        this.onPlayerChanged = this.onPlayerChanged.bind(this);
        this.OnUIStateChange = this.OnUIStateChange.bind(this);
        this.UpdateCurrentPlanet = this.UpdateCurrentPlanet.bind(this);
    }

    Init() {
        this.gameController = new EpochsController();

        this.TapChallengeMode = new TapChallengeMode();
        this.TapChallengeMode.on("Activated", this.HandleTapChallengeActivated);
        this.TapChallengeMode.on("Started", this.HandleTapChallengeStarted);

        this.gameController.Init();

        this.gameView = new EpochsView();
        this.gameView.Init(this.gameController);

        Core.Player.on("Changed", this.onPlayerChanged);

        this.UpdateCurrentPlanet();

        if (this.tutorialState == -1) {
            this.tutorialState = Core.Player.DefaultData ? 1 : 0;
        }

        Core.UI.on("StateChanged", this.OnUIStateChange);
        Core.Player.on("CurrentPlanetChanged", this.UpdateCurrentPlanet);
    }

    HandleTapChallengeStarted() {
        if (this.gameController.epochById.get(this.gameView.selectedEpochId).creatures.length == 0) {
            let firstCreatureInEpochId = Core.GameData.Epochs.GetById(this.gameView.selectedEpochId).creatures[0];
            this.gameController.AddCreature(firstCreatureInEpochId, this.GetRandomPointInCameraView(), false, false, false);
        }
    }

    HandleTapChallengeActivated(isActivated) {
        if (isActivated) {
            Core.UI.game.Hide();
            Core.UI.moneyButtons.Hide();
            this.on("CreatureClick", this.HandleCreatureClick);
        } else {
            Core.UI.game.Show();
            Core.UI.moneyButtons.Show();
            this.off("CreatureClick", this.HandleCreatureClick);
        }
    }

    HandleCreatureClick(controller, clickReward = 0n) {
        if (this.TapChallengeMode.IsInProgress) {
            this.TapChallengeMode.AddScore(clickReward);
        }
    }

    OnUIStateChange(state) {
        let isBank = state == UIState.BankHard || state == UIState.BankSoft || state == UIState.Boosters;
        this.gameView.SetActive(state == UIState.Game || isBank);
    }

    OnDestroy() {
        Core.Player.off("Changed", this.onPlayerChanged);
        Core.UI.off("StateChanged", this.OnUIStateChange);
        this.off("CreatureClick", this.HandleCreatureClick);
    }

    onPlayerChanged() {
    }

    // PlanetSave planet
    initializePlanet(planet) {
        this.Prespawn = true;
        this.gameView.ClearBubbles();
        this.gameController.ClearAll();

        for (let c of planet.creatures) {
            this.gameController.AddCreature(c, this.GetRandomPointInCameraView(), false, false, false);
        }

        for (let i = 0; i < planet.bubbles; i++) {
            this.spawnBubble();
        }

        this.Prespawn = false;
    }

    tick(delta) {
        this.Update();
    }

    Update() {

        if (!Core.UI.gdpr || !Core.UI.gdpr.shown) return;

        this.updateGame();
        if (this.tutorialState == 0) {
            this.updateBubbles();
        } else {
            this.updateTutorial();
        }
        this.updateSpinsTimer();

        this.TapChallengeMode.Update();
        this.gameView.Update();
    }

    updateSpinsTimer() {
        if (!Core.Time || !Core.Time.Initialized) return;
        if (!Core.Player || !Core.Player.Initialized) return;
        if (Core.Player.SpinsNumber >= Core.Player.MaxSpinsNumber) return;

        let secondsFromLastRestore = Core.Player.Timers.TicksFromLastSpinsRestore / 1000;
        if (secondsFromLastRestore > Core.GameData.Config.spinsRestorePeriod) {
            Core.Player.AddMoney(MoneyType.Spins, Core.GameData.Slots.restoreSpinsNumberByTime);
            Core.Player.Timers.LastSpinsRestoreTicks += Core.GameData.Config.spinsRestorePeriod * 1000;
        }
    }

    _tutorialBubbleSpawn() {
        Core.UI.tutorial.SetHandActive(false);
        this.spawnBubble();
        console.log("SPAWN BUBBLE", this.tutorialState);
        this.tutorialState++;
        this.tutorialTimer = 0;
    }

    _tutorialBubbleWait(t = 1) {
        if (Core.Player.PlanetsSave.TutorSave.bubbles === 2) {
            Core.UI.tutorial.SetHandActive(false);
            return this.tutorialState++;
        }
        this.tutorialTimer += Time.deltaTime;
        if (!this.gameView.bubbleViews) return;
        if (!this.gameView.bubbleViews.length) {
            this.spawnBubble();
            this.tutorialTimer = 0;
        }
        if (this.tutorialTimer > t) {
            if (this.gameView.bubbleViews && this.gameView.bubbleViews.length > 0 && !Core.UI.tutorial.hand.Active) {
                Core.UI.tutorial.ShowObjectHand(this.gameView.bubbleViews[0], this.gameView.vfxContainer);
                this.gameView.bubbleViews[0].once("Opened", () => {
                    this.tutorialState++;
                    Core.UI.tutorial.HideObjectHand();
                });
            }
        }
    }

    _tutorialMergeWait(t) {
        if (Core.Player.PlanetsSave.TutorSave.merged) {
            Core.UI.tutorial.SetHandActive(false);
            return this.tutorialState++;
        }
        this.tutorialTimer += Time.deltaTime;
        if (this.tutorialTimer > t && this.gameView.pointerEntities.size === 0) {
            if (this.gameView.creatureViews && this.gameView.creatureViews.length > 1 && !Core.UI.tutorial.hand.Active) {
                Core.UI.tutorial.SetHandActive(true);
                Core.UI.tutorial.HandPointToFrom(this.gameView.creatureViews[0], this.gameView.creatureViews[1], this.gameView.vfxContainer);
                this.gameView.once("pointerdown", () => {
                    this.tutorialTimer = 0;
                    Core.UI.tutorial.SetHandActive(false);
                })

            }
        } else {
            Core.UI.tutorial.SetHandActive(false);
        }
    }

    updateTutorial() {

        if (Core.UI.tutorial.isShowingSomething) {
            Core.UI.tutorial.UpdateObjectHand();
        }

        switch (this.tutorialState) {

            case TUTORIAL_STATE.BUBBLE1:
                if (Core.Player.PlanetsSave.TutorSave.bubbles > 0) {
                    Core.UI.tutorial.SetHandActive(false);
                    this.tutorialState = TUTORIAL_STATE.BUBBLE2;
                }
                else {
                    this._tutorialBubbleSpawn();
                }
                break;

            case TUTORIAL_STATE.WAIT_BUBBLE1: // wait for bubble action
                if (Core.Player.PlanetsSave.TutorSave.bubbles > 1) {
                    Core.UI.tutorial.SetHandActive(false);
                    this.tutorialState = TUTORIAL_STATE.BUBBLE2;
                }
                else {
                    this._tutorialBubbleWait(2);
                }
                break;

            case TUTORIAL_STATE.BUBBLE2:
                if (Core.Player.PlanetsSave.TutorSave.bubbles > 1) {
                    Core.UI.tutorial.SetHandActive(false);
                    this.tutorialState = TUTORIAL_STATE.MERGE;
                }
                else {
                    this._tutorialBubbleSpawn();
                }
                break;

            case TUTORIAL_STATE.WAIT_BUBBLE2: // wait for bubble action
                if (Core.Player.PlanetsSave.TutorSave.bubbles > 1) {
                    Core.UI.tutorial.SetHandActive(false);
                    this.tutorialState = TUTORIAL_STATE.MERGE;
                }
                else {
                    this._tutorialBubbleWait(1.5);
                }
                break;

            case TUTORIAL_STATE.MERGE: // wait for first merge
                Core.Player.PlanetsSave.TutorSave.bubbles = 3;
                if (Core.Player.PlanetsSave.TutorSave.merged) {
                    this.tutorialState++;
                } else {
                    this._tutorialMergeWait(1);
                }
                break;

            case TUTORIAL_STATE.MERGED:
                Core.Player.PlanetsSave.TutorSave.merged = true;
                Core.UI.tutorial.SetHandActive(false);
                this.tutorialState++;
                this.timeOfLastBubbleSpawn = Time.time;
                break;

            case TUTORIAL_STATE.BUBBLE3:
                this.spawnBubble();
                this.tutorialState++;
                break;

            case 300:
                this.spawnBubble();
                this.spawnBubble();
                this.tutorialState++;
                break;

            case 600:
                this.spawnBubble();
                this.tutorialState++;
                break;

            case 900:
                this.spawnBubble();
                this.spawnBubble();
                this.tutorialState++;
                break;

            case 1300:
                this.spawnBubble();
                this.tutorialState++;
                break;

            case 1600:
                this.spawnBubble();
                this.tutorialState = 0;
                break;

            default:
                if (this.tutorialState > TUTORIAL_STATE.BUBBLE3) this.tutorialState++;
                break;
        }

        if (this.tutorialState > 7) {
            this.updateBubbles();
        }
    }

    updateBubbles() {
        if (this.timeFromLastBubbleSpawn < 0) {
            this.timeOfLastBubbleSpawn = Time.time;
        }
        let secondsFromLastBubbleSpawn = this.timeFromLastBubbleSpawn;
        let bubblesToSpawn = ~~(secondsFromLastBubbleSpawn / this.bubbleSpawnPeriod);
        for (let i = 0; i < bubblesToSpawn; i++) {
            if (!this.spawnBubble()) {
                break;
            } else {
                this.timeOfLastBubbleSpawn = Time.time;
            }
        }
    }

    spawnBubble() {
        let epochId = 1;
        if (this.gameController.epochById.get(epochId).SpawnBubble()) {
            this.gameView.SpawnBubble();
            this.updateTimers();
            return true;
        }
        return false;
    }

    spawnEventCreature(guid, creatureId, epochId, checkForEmptySpace) {
    }

    updateTimers() {
        let bubbleUpgradeData = Core.GameData.Upgrades.UpgradeByType(UpgradeType.BubbleTime);
        let bubbleProgress = Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.BubbleTime);
        this.bubbleSpawnPeriod = bubbleUpgradeData.TotalValue(bubbleProgress.upgradeIndex);
        if (Core.Boosters.IsBubbleActive) {
            this.bubbleSpawnPeriod *= 0.5;
        }
    }

    updateGame() {
        let deltaTime = Time.deltaTime;
        this.timeFromLastUpdate += deltaTime;
        if (this.timeFromLastUpdate >= UPDATE_PERIOD) {
            this.gameController.Step(1);
            this.timeFromLastUpdate -= 1;
        }
    }
}

export const GameManager = new GameManagerClass();
window.GameManager = GameManager;
